import { Contact, VatNumberType } from 'modules/Contacts/models/models';
import { VerifactuVatNumberType } from 'modules/Documents/models/verifactuDocument';
import { VerifactuInvoice } from 'modules/Documents/models/verifactuInvoice';

export const normalizeVerifactuCounterpartyToContact = (
  verifactuInvoice: VerifactuInvoice
): Contact | undefined => {
  const { frozenCounterparty, counterparty } = verifactuInvoice;

  if (!frozenCounterparty) {
    return undefined;
  }

  return {
    id: counterparty?.id,
    fiscalName: frozenCounterparty?.fiscalName,
    vatNumber: frozenCounterparty?.vatNumber,
    vatNumberType: normalizeVerifactuVatNumberTypeToVatNumberType(
      frozenCounterparty?.vatNumberType
    ),
    address: {
      postalAddress: frozenCounterparty?.address.postalAddress,
      postalCode: frozenCounterparty?.address.postalCode,
      city: frozenCounterparty?.address.city,
      province: frozenCounterparty?.address.province,
      country: frozenCounterparty?.address.country,
    },
  };
};

const VatNumberTypeMap: Record<VerifactuVatNumberType, VatNumberType> = {
  [VerifactuVatNumberType.NIF]: VatNumberType.NIF,
  [VerifactuVatNumberType.NIF_IVA]: VatNumberType.NIF_IVA,
  [VerifactuVatNumberType.PASSPORT]: VatNumberType.PASSPORT,
  [VerifactuVatNumberType.ORIGIN]: VatNumberType.ORIGIN,
  [VerifactuVatNumberType.CERTIFICATE]: VatNumberType.CERTIFICATE,
  [VerifactuVatNumberType.OTHER]: VatNumberType.OTHER,
};

const normalizeVerifactuVatNumberTypeToVatNumberType = (
  verifactuVatNumberType: VerifactuVatNumberType
): VatNumberType => {
  return VatNumberTypeMap[verifactuVatNumberType] ?? VatNumberType.NIF;
};
